const GroupType = {

  // FIELDS
  "name": "Name",
  "description": "Description",
  "status": "Status",
  "search": "Search",

  // PAGE HEADER
  "group_type": "Group Type",

  // ERROR
  "error_name": "Enter Name",
  "error_desc": "Enter Description",
  "error_status": "Select Status",

  // TABLE HEADER
  "table_name": 'NAME',
  "table_description": "DESCRIPTION",
  "table_status": "STATUS",

}

export default GroupType;
